import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-171eacbf"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "investigate-content"
};
var _hoisted_2 = {
  class: "main-box"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "header-box"
  }, [/*#__PURE__*/_createElementVNode("p", {
    class: "title"
  }, "感谢您的宝贵意见！")], -1);
});

var _hoisted_4 = {
  class: "form-content"
};
var _hoisted_5 = {
  class: "fx-c-fs form-container"
};
var _hoisted_6 = {
  class: "description-box"
};
var _hoisted_7 = {
  class: "fx-c-fs",
  style: {
    "width": "100%"
  }
};
var _hoisted_8 = {
  style: {
    "display": "flex",
    "justify-content": "center"
  }
};

var _hoisted_9 = /*#__PURE__*/_createTextVNode(" 提交 ");

import { ref, toRefs } from 'vue';
import { NModal, NForm, NFormItem, NInput, NSpin } from 'naive-ui';
export default /*#__PURE__*/_defineComponent({
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:show'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;

    var _toRefs = toRefs(props),
        show = _toRefs.show;

    var reqLoading = ref(false);
    var feedbackFormRef = ref(null);
    var feedbackFormValue = ref({
      content: '',
      img: '' // 意见

    });
    var insterestRules = ref({// content: {
      //   required: true,
      //   message: "请填写意见",
      //   // trigger: "blur"
      // }
    });

    function handleModelClose() {
      feedbackFormValue.value = {
        content: '',
        img: '' // 意见

      };
      emit('update:show', false);
      reqLoading.value = false;
    } // 提交


    var handleSubmit = function handleSubmit(e) {
      var _feedbackFormValue$va;

      var f = window;

      if (!((_feedbackFormValue$va = feedbackFormValue.value) !== null && _feedbackFormValue$va !== void 0 && _feedbackFormValue$va.content)) {
        f.$message.info('请输入反馈内容');
        return;
      }

      reqLoading.value = true;
      setTimeout(function () {
        f.$message.success('提交成功');
        handleModelClose();
      }, 500);
    };

    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(_unref(NModal), {
        class: "feedback-modal",
        style: {
          "width": "85%",
          "max-width": "800PX",
          "padding": "0PX"
        },
        show: _unref(show),
        "onUpdate:show": _cache[1] || (_cache[1] = function ($event) {
          return _isRef(show) ? show.value = $event : null;
        }),
        preset: "dialog",
        "show-icon": false,
        onClose: handleModelClose,
        onMaskClick: handleModelClose
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_unref(NForm), {
            ref_key: "feedbackFormRef",
            ref: feedbackFormRef,
            model: _unref(feedbackFormValue),
            rules: insterestRules.value,
            "label-width": "100",
            size: "medium"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(NFormItem), {
                label: "您的意见",
                path: "content"
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_7, [_createVNode(_unref(NInput), {
                    value: _unref(feedbackFormValue).content,
                    "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
                      return _unref(feedbackFormValue).content = $event;
                    }),
                    placeholder: "请输入您的宝贵意见～",
                    size: "large",
                    autosize: {
                      minRows: 5,
                      maxRows: 5
                    },
                    type: "textarea",
                    maxlength: 2000,
                    "show-count": ""
                  }, null, 8, ["value"])])];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["model", "rules"])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
            class: "start-btn",
            onClick: handleSubmit
          }, [reqLoading.value ? (_openBlock(), _createBlock(_unref(NSpin), {
            key: 0,
            size: 14,
            stroke: "#b1b0bc",
            style: {
              "margin-right": "10PX"
            }
          })) : _createCommentVNode("", true), _hoisted_9])])])])])])];
        }),
        _: 1
      }, 8, ["show"]);
    };
  }
});